import React from 'react';

const TimeHeader = ({dayData}) => {
    return (
        <thead className="bg-custom-charcoal sticky top-0">
            <tr>
                <th className="pl-2 py-1 text-xs text-custom-light-grey font-semibold rounded-tl-lg border-b border-custom-charcoal">
                        <div className="flex items-center gap-2">
                            <span>Metric</span>
                    </div>
                </th>
                {dayData.map(({ time }, index) => {
                    //convert 6:00 am to 6am without spaces to lowercase
                    const hour = new Date(time).toLocaleTimeString('en-US', { hour: 'numeric', hour12: true }).replace(':00', '').replace(' ', '').toLowerCase();
                    return (
                        <th key={time} className={`py-1 text-sm font-semibold text-center border-b border-custom-charcoal ${index === dayData.length - 1 ? 'rounded-tr-lg' : ''}`}>
                            <div className="inline-block min-w-[30px] py-1 font-semibold text-xs">
                                {hour}
                            </div>
                        </th>
                    )
                })}
            </tr>
        </thead>
    )
}

export default TimeHeader;